import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import "./i18n";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { Environment } from "./shared/environment/features/environment";
import CrudFilterProvider from "./root/general/infrastructure/contexts/CrudFilterProvider";
import { EventPollingProvider } from "./root/event/modules/features/EventPollingProvider";
import * as Sentry from "@sentry/react";

if (
  Environment.APP_ENVIRONMENT === "testing" ||
  Environment.APP_ENVIRONMENT === "production"
) {
  Sentry.init({
    dsn: "https://da986af47f647f5e3f8bfd0141c2cf5e@o4505787542470656.ingest.us.sentry.io/4510266637418496",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: Environment.APP_ENVIRONMENT,
  });
}

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.baseURL = Environment.API_BASE_URL;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <CrudFilterProvider>
        <EventPollingProvider>
          <App />
        </EventPollingProvider>
      </CrudFilterProvider>
    </BrowserRouter>
  </Provider>
);

// Only enable StrictMode in development
root.render(
  process.env.NODE_ENV === "development" ? (
    <React.StrictMode>{app}</React.StrictMode>
  ) : (
    app
  ),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
